
import { lazy } from "react";
import ArticleIcon from "@mui/icons-material/Article";

const LogsList = lazy(() => import("../components/logsList"));

const LogsRoute = {
  icon: ArticleIcon,
  // name: "Logs",
  link: "/logs",
  path: "logs",
  index: 10,
  element: <LogsList />,
};
export default LogsRoute;
